"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { MarkdownRenderer, Text } from "@nxt-costco-com/forge-components";
import { ColorTextDefault } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
import GenericImageHandler from "../../Util/GenericImageHandler.js";
import { DEFAULT_MARKDOWN_TEXT_COLOR } from "./constants.js";
import { generateBackgroundStyles } from "./util.js";
import { StyledOverlayTileBox, StyledPillContainer, StyledOverlay, StyledOverlayText, StyledOverlayTextContainer, StyledOverlayMarkdown } from "./styles.js";
function OverlayTile({
  content
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  if (!content) {
    return null;
  }
  return /* @__PURE__ */ jsxs(StyledOverlayTileBox, { children: [
    /* @__PURE__ */ jsx(StyledPillContainer, { children: /* @__PURE__ */ jsxs(
      StyledOverlay,
      {
        sx: {
          background: generateBackgroundStyles(
            content == null ? void 0 : content.overlay_color
          )
        },
        children: [
          ((_b = (_a = content == null ? void 0 : content.overlay_icon) == null ? void 0 : _a[0]) == null ? void 0 : _b.url) && /* @__PURE__ */ jsx(
            GenericImageHandler,
            {
              style: {
                maxHeight: "14px",
                padding: "1px 1px",
                width: "60px"
              },
              alt: (content == null ? void 0 : content.overlay_icon_alt_text) || "",
              src: (_d = (_c = content == null ? void 0 : content.overlay_icon) == null ? void 0 : _c[0]) == null ? void 0 : _d.url
            }
          ),
          /* @__PURE__ */ jsx(CostcoBox, { sx: {}, children: /* @__PURE__ */ jsx(
            StyledOverlayText,
            {
              textColor: ((_f = (_e = content == null ? void 0 : content.overlay_color) == null ? void 0 : _e.text_color) == null ? void 0 : _f.hex) || ColorTextDefault,
              children: content == null ? void 0 : content.overlay_text
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(
      StyledOverlayTextContainer,
      {
        sx: {
          background: generateBackgroundStyles(
            content == null ? void 0 : content.markdown_color
          )
        },
        children: /* @__PURE__ */ jsx(CostcoBox, { sx: {}, children: /* @__PURE__ */ jsx(
          StyledOverlayMarkdown,
          {
            textColor: ((_h = (_g = content == null ? void 0 : content.markdown_color) == null ? void 0 : _g.text_color) == null ? void 0 : _h.hex) || DEFAULT_MARKDOWN_TEXT_COLOR,
            children: /* @__PURE__ */ jsx(
              MarkdownRenderer,
              {
                overrides: {
                  p: {
                    component: Text,
                    props: {
                      component: "p",
                      sx: {
                        color: ((_j = (_i = content == null ? void 0 : content.markdown_color) == null ? void 0 : _i.text_color) == null ? void 0 : _j.hex) || DEFAULT_MARKDOWN_TEXT_COLOR
                      }
                    }
                  }
                },
                markdown: content == null ? void 0 : content.markdown
              }
            )
          }
        ) })
      }
    )
  ] });
}
export {
  OverlayTile
};
